import { Chip, styled } from '@cherre-frontend/ui';

export const StyledChip = styled(Chip)`
  height: 21px;
  width: fit-content;
  color: white;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  color: #df2467;
`;
